// extracted by mini-css-extract-plugin
export default {"customWidth":"Register_customWidth__Yh9uf","defLink":"Register_defLink__u-ZQ-"};